import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Hdd = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.983 13.821l-1.851-10.18A1.998 1.998 0 0018.165 2H5.835a2 2 0 00-1.968 1.643l-1.85 10.178.019.003c-.012.06-.036.114-.036.176v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c0-.063-.024-.116-.035-.176l.018-.003zM5.835 4h12.331l1.637 9H4.198l1.637-9zM4 19v-4h16l.002 4H4z",
    key: "k0"
  }), React.createElement("path", {
    d: "M17 16h2v2h-2zm-3 0h2v2h-2z",
    key: "k1"
  }));
});
Hdd.displayName = 'Hdd';
export var HddDimensions = {
  height: 24,
  width: 24
};